module.exports = __webpack_public_path__ + "static/media/icon.6b37b3e4.png";